// 解析 LRC 格式歌词
export const parseLRC = (content) => {
  const lines = String(content || '').split('\n');
  const lyrics = [];

  for (const line of lines) {
    // 支持多种 LRC 时间格式：
    // [mm:ss.ff] - 标准格式（分钟:秒.百分秒）
    // [mm:ss:ff] - 另一种格式（分钟:秒:百分秒）
    // [m:ss.ff] 或 [mm:s.ff] - 单数字分钟或秒
    let match = line.match(/\[(\d{1,2}):(\d{2})\.(\d{2})\](.*)/);
    if (!match) {
      match = line.match(/\[(\d{1,2}):(\d{2}):(\d{2})\](.*)/);
    }

    if (match) {
      const minutes = parseInt(match[1], 10);
      const seconds = parseInt(match[2], 10);
      const centiseconds = parseInt(match[3], 10);
      const time = minutes * 60 + seconds + centiseconds / 100;
      const text = match[4].trim();
      if (text) {
        lyrics.push({ time, text });
      }
    }
  }

  const sorted = lyrics.sort((a, b) => a.time - b.time);
  // 保留原有调试输出（开发/线上由调用方控制）
  console.log('Parsed LRC:', {
    totalLines: lines.length,
    parsedCount: sorted.length,
    firstTime: sorted[0]?.time,
    lastTime: sorted[sorted.length - 1]?.time
  });
  return sorted;
};

// 解析 SRT 格式歌词
export const parseSRT = (content) => {
  const blocks = String(content || '').split(/\n\n+/);
  const lyrics = [];

  for (const block of blocks) {
    const lines = block.split('\n');
    if (lines.length < 3) continue;

    const timeMatch = lines[1].match(/(\d{2}):(\d{2}):(\d{2})[,.](\d{3})\s*-->\s*(\d{2}):(\d{2}):(\d{2})[,.](\d{3})/);
    if (timeMatch) {
      const startTime =
        parseInt(timeMatch[1], 10) * 3600 +
        parseInt(timeMatch[2], 10) * 60 +
        parseInt(timeMatch[3], 10) +
        parseInt(timeMatch[4], 10) / 1000;
      const text = lines.slice(2).join('\n').trim();
      if (text) {
        lyrics.push({ time: startTime, text });
      }
    }
  }

  return lyrics.sort((a, b) => a.time - b.time);
};

